var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "custom-tabs"
  }, [_c('div', {
    staticClass: "tabs-header"
  }, [_vm._l(_vm.tabs, function (tab, index) {
    return _c('div', {
      key: index,
      ref: "tabItems",
      refInFor: true,
      staticClass: "tab-item",
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function ($event) {
          return _vm.switchTab(index);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.name) + " ")]);
  }), _c('div', {
    staticClass: "active-indicator",
    style: _vm.indicatorStyle
  })], 2), _c('div', {
    staticClass: "tabs-content"
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };